import axios, {AxiosInstance,AxiosRequestConfig} from "axios"


//AxiosRequestConfig config的类型
//AxiosInstance instance的类型
//创建axios拦截器
export const createAxiosByinterceptors = (
    config?:AxiosRequestConfig
):AxiosInstance => {
    const instance = axios.create({
        timeout:20000, //超时配置
        ...config, // 自定义配置
    })

    // 添加请求拦截
    instance.interceptors.request.use(
        (config:any) => {
            if(sessionStorage.getItem("token")){
                config.headers["token"] = sessionStorage.getItem("token")
              }
           // config.headers["token"] = "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJjYTk3NDhhZGRmNmQ0NGZiYWY0Mzc4YzM1MDA5NGM2YSIsInN1YiI6IjkiLCJpc3MiOiJ3eG0iLCJpYXQiOjE2Njk2MjM5OTEsImV4cCI6MTY2OTY2NzE5MX0.-wMkAMtSFfVlYbVxI3Yd6AwtYeSe8fTliQRKMt3qCRo"
            return config
        },
        (error) =>{
            return Promise.reject(error)
        }
    )

    //添加响应拦截
    instance.interceptors.response.use((res) => {
        if(res.data.status ==200) return res.data;
        else if(res.data.status === 401){
            return res.data
        }else{
            return res.data
        }
    },(error) => {
        return error
    })



    return instance
}
